import script from "./DecorBackground.vue?vue&type=script&setup=true&lang=js"
export * from "./DecorBackground.vue?vue&type=script&setup=true&lang=js"

import "./DecorBackground.vue?vue&type=style&index=0&id=75a81b45&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75a81b45"]])

export default __exports__